// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ResetPassword_container__FVGqc{
    display: flex;
    flex-direction: row-reverse;
    height: 100%;
    padding-top: 30px;
}
.ResetPassword_banner__P2-nF{
    height: auto;
    width: 40%;
    padding-bottom: 50px;
}
@media(max-width: 1180px){
    .ResetPassword_container__FVGqc{
        display: block;
        height: auto;
    }
    .ResetPassword_banner__P2-nF{
        display: flex;
        flex-direction: column-reverse;
        width: 100%;
        margin-top: -25px;
    }
}
@media(max-width: 600px){
    .ResetPassword_container__FVGqc{
        min-height: calc(100vh - 104px);
        padding-top: 0;
    }
}
.ResetPassword_image__RYgab{
    height: 100%;
    max-height: 100%;
    width: 100%;
    border-radius: 30px 30px 30px 30px;
    object-fit: cover;
}
@media(max-width: 1180px){
    .ResetPassword_image__RYgab{
        margin-top: -30px;
        object-position: top;
    }
}
.ResetPassword_formContainer__5yq3l{
    display: flex;
    justify-content: center;
    height: calc(100vh - 174px);
    width: 60%;
    padding-top: 70px;
}
@media(max-width: 1180px){
    .ResetPassword_formContainer__5yq3l{
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        height: 600px;
        width: 500px;
        padding-top: 0;
    }
}
@media(max-width: 600px){
    .ResetPassword_formContainer__5yq3l{
        height: auto;
        width: calc(100% - 30px);
        margin: 30px 15px 120px 15px;
    }
}
.ResetPassword_form__Jowvb{
    width: 500px;
}
.ResetPassword_formNamesRow__dKbmG{
    display: flex;
}
.ResetPassword_header__g-vXJ{
    text-align: left !important;
}
.ResetPassword_description__yL\\+4G{
    margin-top: -12px;
    margin-bottom: 45px;
    padding-left: 2px;
}
.ResetPassword_name__--Cwa input{
    width: 190px;
}
.ResetPassword_singleLineInput__ZeCp0{
    display: block !important;
    margin-top: 15px;
}
.ResetPassword_singleLineInput__ZeCp0 input{
    width: calc(100% - 40px);
}
@media(max-width: 600px){
    .ResetPassword_form__Jowvb{
        width: 100%;
    }
    .ResetPassword_formNamesRow__dKbmG{
        display: block;
    }
    .ResetPassword_name__--Cwa{
        display: block !important;
        margin-top: 15px;
    }
    .ResetPassword_name__--Cwa input{
        width: calc(100% - 45px);
    }
    .ResetPassword_singleLineInput__ZeCp0 input{
        width: calc(100% - 45px);
    }
}
.ResetPassword_formBottom__-r8ro{
    display: flex;
    align-items: center;
    margin-top: 50px;
}
.ResetPassword_invalidTokenDescription__yKAI0{
    text-align: center;
}
.ResetPassword_shieldCheckmark__RkvUi{
    height: 60px;
    width: 60px;
}
.ResetPassword_resetSuccessfulHeader__4a8tg{
    margin-top: 35px;
    margin-bottom: 25px;
    font-size: 31px;
    font-family: "Gotham Bold", serif;
}`, "",{"version":3,"sources":["webpack://./src/pages/ResetPassword.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,UAAU;IACV,oBAAoB;AACxB;AACA;IACI;QACI,cAAc;QACd,YAAY;IAChB;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,WAAW;QACX,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,+BAA+B;QAC/B,cAAc;IAClB;AACJ;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,kCAAkC;IAClC,iBAAiB;AACrB;AACA;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,UAAU;IACV,iBAAiB;AACrB;AACA;IACI;QACI,OAAO;QACP,QAAQ;QACR,iBAAiB;QACjB,kBAAkB;QAClB,aAAa;QACb,YAAY;QACZ,cAAc;IAClB;AACJ;AACA;IACI;QACI,YAAY;QACZ,wBAAwB;QACxB,4BAA4B;IAChC;AACJ;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,cAAc;IAClB;IACA;QACI,yBAAyB;QACzB,gBAAgB;IACpB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iCAAiC;AACrC","sourcesContent":[".container{\n    display: flex;\n    flex-direction: row-reverse;\n    height: 100%;\n    padding-top: 30px;\n}\n.banner{\n    height: auto;\n    width: 40%;\n    padding-bottom: 50px;\n}\n@media(max-width: 1180px){\n    .container{\n        display: block;\n        height: auto;\n    }\n    .banner{\n        display: flex;\n        flex-direction: column-reverse;\n        width: 100%;\n        margin-top: -25px;\n    }\n}\n@media(max-width: 600px){\n    .container{\n        min-height: calc(100vh - 104px);\n        padding-top: 0;\n    }\n}\n.image{\n    height: 100%;\n    max-height: 100%;\n    width: 100%;\n    border-radius: 30px 30px 30px 30px;\n    object-fit: cover;\n}\n@media(max-width: 1180px){\n    .image{\n        margin-top: -30px;\n        object-position: top;\n    }\n}\n.formContainer{\n    display: flex;\n    justify-content: center;\n    height: calc(100vh - 174px);\n    width: 60%;\n    padding-top: 70px;\n}\n@media(max-width: 1180px){\n    .formContainer{\n        left: 0;\n        right: 0;\n        margin-left: auto;\n        margin-right: auto;\n        height: 600px;\n        width: 500px;\n        padding-top: 0;\n    }\n}\n@media(max-width: 600px){\n    .formContainer{\n        height: auto;\n        width: calc(100% - 30px);\n        margin: 30px 15px 120px 15px;\n    }\n}\n.form{\n    width: 500px;\n}\n.formNamesRow{\n    display: flex;\n}\n.header{\n    text-align: left !important;\n}\n.description{\n    margin-top: -12px;\n    margin-bottom: 45px;\n    padding-left: 2px;\n}\n.name input{\n    width: 190px;\n}\n.singleLineInput{\n    display: block !important;\n    margin-top: 15px;\n}\n.singleLineInput input{\n    width: calc(100% - 40px);\n}\n@media(max-width: 600px){\n    .form{\n        width: 100%;\n    }\n    .formNamesRow{\n        display: block;\n    }\n    .name{\n        display: block !important;\n        margin-top: 15px;\n    }\n    .name input{\n        width: calc(100% - 45px);\n    }\n    .singleLineInput input{\n        width: calc(100% - 45px);\n    }\n}\n.formBottom{\n    display: flex;\n    align-items: center;\n    margin-top: 50px;\n}\n.invalidTokenDescription{\n    text-align: center;\n}\n.shieldCheckmark{\n    height: 60px;\n    width: 60px;\n}\n.resetSuccessfulHeader{\n    margin-top: 35px;\n    margin-bottom: 25px;\n    font-size: 31px;\n    font-family: \"Gotham Bold\", serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ResetPassword_container__FVGqc`,
	"banner": `ResetPassword_banner__P2-nF`,
	"image": `ResetPassword_image__RYgab`,
	"formContainer": `ResetPassword_formContainer__5yq3l`,
	"form": `ResetPassword_form__Jowvb`,
	"formNamesRow": `ResetPassword_formNamesRow__dKbmG`,
	"header": `ResetPassword_header__g-vXJ`,
	"description": `ResetPassword_description__yL+4G`,
	"name": `ResetPassword_name__--Cwa`,
	"singleLineInput": `ResetPassword_singleLineInput__ZeCp0`,
	"formBottom": `ResetPassword_formBottom__-r8ro`,
	"invalidTokenDescription": `ResetPassword_invalidTokenDescription__yKAI0`,
	"shieldCheckmark": `ResetPassword_shieldCheckmark__RkvUi`,
	"resetSuccessfulHeader": `ResetPassword_resetSuccessfulHeader__4a8tg`
};
export default ___CSS_LOADER_EXPORT___;
